import type { SVGProps } from 'react';
const SvgDeleteSteamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Delete 1 Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M16.518 1.982 1.982 16.518M1.982 1.982l14.536 14.536" />
    </g>
  </svg>
);
export default SvgDeleteSteamlineCore;
